<template>
    <cp-select
        :config="routeCompanies"
        item-value="id"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
        :customItem="true"
    >
        <template v-slot:selection="{ item }">
            {{ `${item.trade_name} - Doc: ${item.document}` }}
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-content>
                    <v-list-item-title>
                        <strong>Razão Social:</strong> {{ item.legal_name }}<br>
                        <strong>Nome Fantasia:</strong> {{ item.trade_name }}<br>
                        <strong>Documento:</strong> {{ item.document }}<br>
                        <strong>ID da Loja:</strong> {{ item.store_id }}<br>
                        <strong>ID do Hubspot:</strong> {{ item.hubspot_id }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        routeCompanies: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.core.dd_companies'} },
        },
    },
    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione uma Empresa',
                name: name || "select-company"
            }, ...attrs };
        },
    },

    methods: {
        contractId(schema) {
            return schema ? schema.replace('u', '') : ''
        }
    }
}
</script>